import React from "react";

const PasswordResetSuccessful = ({ id, isPasswordResetSuccessfulOpen }) => {
  return (
    <>
      <div
        id={id}
        className={`${
          isPasswordResetSuccessfulOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[40%] mx-auto">
            <div className="mb-4 mx-auto items-center justify-center">
              <div className="h-[250px] w-full flex flex-col gap-[20px] items-center justify-center">
                <svg
                  width="110"
                  height="110"
                  viewBox="0 0 110 110"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="55" cy="55" r="55" fill="#074073" />
                  <path
                    d="M19.5 57L39.5 74.0514L88.5 29.5"
                    stroke="white"
                    stroke-width="5"
                  />
                </svg>

                <p className="items-center text-center font-[400] text-[16px]">
                  Password Reset Email has been sent to the User
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordResetSuccessful;
